import { render, staticRenderFns } from "./kuailonOrder.vue?vue&type=template&id=02996add&scoped=true&"
import script from "./kuailonOrder.vue?vue&type=script&lang=js&"
export * from "./kuailonOrder.vue?vue&type=script&lang=js&"
import style0 from "./kuailonOrder.vue?vue&type=style&index=0&id=02996add&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02996add",
  null
  
)

export default component.exports